import './style.scss';
import '../styles/scss/helpers/_media-queries.scss';
import PageRenderer from '../components/page-renderer';
import LedIndicator from '../features/led-indicator/LedIndicator';

function App() {
	return (
		<>
			<LedIndicator />
			<PageRenderer />
		</>
	);
}

export default App;
